import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private permissionsSubject = new BehaviorSubject<any[]>([]);
  permissions$ = this.permissionsSubject.asObservable(); // Expose as Observable

  userProfile: any;
  user: any;

  constructor(private appService: AppService) {
    this.user = JSON.parse(localStorage.getItem('office_q_uid'));
  }

  ngOnInit(): void {
    this.userList();
  }
  refreshUser(): void {
    this.user = JSON.parse(localStorage.getItem('office_q_uid'));
  }

  userList() {
    this.refreshUser();
    if (!this.user || !this.user.UserId) {
      console.error('UserId is missing. Please log in again.');
      return;
    }
    this.appService.postService({ Id: this.user.UserId }, 'UserGetById')
      .subscribe(response => {
        this.userProfile = response.body.Result;
        console.log('this.userProfile: ', this.userProfile);
        console.log('this.userProfile.AssignedPermission: ', localStorage);
        if (localStorage.getItem('office_q_uid') != null) {

          let user = JSON.parse(localStorage.getItem('office_q_uid'));
          user.AssignedPermission = this.userProfile.AssignedPermission;

          console.log('  user.AssignedPermission: ', user.AssignedPermission);
          localStorage.setItem('office_q_uid', JSON.stringify(user));

          setTimeout(() => { this.loadPermissions(); }, 1000);


        }
      });

  }

  loadPermissions() {
    const userData = localStorage.getItem('office_q_uid');
    if (userData) {
      const parsedData = JSON.parse(userData);
      const permissions = parsedData.AssignedPermission || [];
      this.permissionsSubject.next(permissions); // Update the BehaviorSubject
    }
  }

  hasPermission(moduleId: number, action: 'Add' | 'Edit' | 'Delete' | 'View') {
    const permissions = this.permissionsSubject.getValue();
    const module = permissions.find(m => m.ModuleId === moduleId);
    return module ? module[action] : false;
  }
}
